module.exports = __webpack_public_path__ + "img/category-fishing-game-hover.345fd24f.png";